// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.35.0
// source: ir/uid/external/base/user.proto

/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { DoubleValue } from "../../../../google/protobuf/wrappers";
import { Status } from "../../../../google/rpc/status";
import { DateMessage } from "../../../../google/type/date";

export const protobufPackage = "ir.uid.base";

export enum Sex {
  SEX_UNDEFINED = 0,
  SEX_MALE = 1,
  SEX_FEMALE = 2,
  UNRECOGNIZED = -1,
}

export function sexFromJSON(object: any): Sex {
  switch (object) {
    case 0:
    case "SEX_UNDEFINED":
      return Sex.SEX_UNDEFINED;
    case 1:
    case "SEX_MALE":
      return Sex.SEX_MALE;
    case 2:
    case "SEX_FEMALE":
      return Sex.SEX_FEMALE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Sex.UNRECOGNIZED;
  }
}

export function sexToJSON(object: Sex): string {
  switch (object) {
    case Sex.SEX_UNDEFINED:
      return "SEX_UNDEFINED";
    case Sex.SEX_MALE:
      return "SEX_MALE";
    case Sex.SEX_FEMALE:
      return "SEX_FEMALE";
    case Sex.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum AuthenticationState {
  AUTHENTICATION_STATE_UNDEFINED = 0,
  AUTHENTICATION_STATE_ACCEPTED = 1,
  AUTHENTICATION_STATE_REJECTED = 2,
  UNRECOGNIZED = -1,
}

export function authenticationStateFromJSON(object: any): AuthenticationState {
  switch (object) {
    case 0:
    case "AUTHENTICATION_STATE_UNDEFINED":
      return AuthenticationState.AUTHENTICATION_STATE_UNDEFINED;
    case 1:
    case "AUTHENTICATION_STATE_ACCEPTED":
      return AuthenticationState.AUTHENTICATION_STATE_ACCEPTED;
    case 2:
    case "AUTHENTICATION_STATE_REJECTED":
      return AuthenticationState.AUTHENTICATION_STATE_REJECTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AuthenticationState.UNRECOGNIZED;
  }
}

export function authenticationStateToJSON(object: AuthenticationState): string {
  switch (object) {
    case AuthenticationState.AUTHENTICATION_STATE_UNDEFINED:
      return "AUTHENTICATION_STATE_UNDEFINED";
    case AuthenticationState.AUTHENTICATION_STATE_ACCEPTED:
      return "AUTHENTICATION_STATE_ACCEPTED";
    case AuthenticationState.AUTHENTICATION_STATE_REJECTED:
      return "AUTHENTICATION_STATE_REJECTED";
    case AuthenticationState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum AuthenticationResponseReason {
  /** AUTHENTICATION_RESPONSE_REASON_UNDEFINED - در حال انتظار */
  AUTHENTICATION_RESPONSE_REASON_UNDEFINED = 0,
  /** AUTHENTICATION_RESPONSE_REASON_ACCEPT - تایید شده */
  AUTHENTICATION_RESPONSE_REASON_ACCEPT = 1,
  /** AUTHENTICATION_RESPONSE_REASON_REJECT_FACE_NOT_MATCH_ID - عدم تطبیق چهره با ثبت احوال */
  AUTHENTICATION_RESPONSE_REASON_REJECT_FACE_NOT_MATCH_ID = 2,
  /** AUTHENTICATION_RESPONSE_REASON_REJECT_VIDEO_NOT_LIVE - زنده نبودن ویدئو ارسالی */
  AUTHENTICATION_RESPONSE_REASON_REJECT_VIDEO_NOT_LIVE = 3,
  /** AUTHENTICATION_RESPONSE_REASON_REJECT_VIDEO_BAD_LIGHT - نور نامناسب */
  AUTHENTICATION_RESPONSE_REASON_REJECT_VIDEO_BAD_LIGHT = 4,
  /** AUTHENTICATION_RESPONSE_REASON_REJECT_VIDEO_BAD_QUALITY - عدم وضوح تصویر */
  AUTHENTICATION_RESPONSE_REASON_REJECT_VIDEO_BAD_QUALITY = 5,
  /** AUTHENTICATION_RESPONSE_REASON_REJECT_PERSON_TOO_FAR_AWAY - فاصله بیش از حد با دوربین */
  AUTHENTICATION_RESPONSE_REASON_REJECT_PERSON_TOO_FAR_AWAY = 6,
  /** AUTHENTICATION_RESPONSE_REASON_REJECT_MORE_THAN_ONE_PERSON - وجود چند چهره */
  AUTHENTICATION_RESPONSE_REASON_REJECT_MORE_THAN_ONE_PERSON = 7,
  /** AUTHENTICATION_RESPONSE_REASON_REJECT_NO_PERSON_DETECTED - عدم وجود چهره */
  AUTHENTICATION_RESPONSE_REASON_REJECT_NO_PERSON_DETECTED = 8,
  UNRECOGNIZED = -1,
}

export function authenticationResponseReasonFromJSON(object: any): AuthenticationResponseReason {
  switch (object) {
    case 0:
    case "AUTHENTICATION_RESPONSE_REASON_UNDEFINED":
      return AuthenticationResponseReason.AUTHENTICATION_RESPONSE_REASON_UNDEFINED;
    case 1:
    case "AUTHENTICATION_RESPONSE_REASON_ACCEPT":
      return AuthenticationResponseReason.AUTHENTICATION_RESPONSE_REASON_ACCEPT;
    case 2:
    case "AUTHENTICATION_RESPONSE_REASON_REJECT_FACE_NOT_MATCH_ID":
      return AuthenticationResponseReason.AUTHENTICATION_RESPONSE_REASON_REJECT_FACE_NOT_MATCH_ID;
    case 3:
    case "AUTHENTICATION_RESPONSE_REASON_REJECT_VIDEO_NOT_LIVE":
      return AuthenticationResponseReason.AUTHENTICATION_RESPONSE_REASON_REJECT_VIDEO_NOT_LIVE;
    case 4:
    case "AUTHENTICATION_RESPONSE_REASON_REJECT_VIDEO_BAD_LIGHT":
      return AuthenticationResponseReason.AUTHENTICATION_RESPONSE_REASON_REJECT_VIDEO_BAD_LIGHT;
    case 5:
    case "AUTHENTICATION_RESPONSE_REASON_REJECT_VIDEO_BAD_QUALITY":
      return AuthenticationResponseReason.AUTHENTICATION_RESPONSE_REASON_REJECT_VIDEO_BAD_QUALITY;
    case 6:
    case "AUTHENTICATION_RESPONSE_REASON_REJECT_PERSON_TOO_FAR_AWAY":
      return AuthenticationResponseReason.AUTHENTICATION_RESPONSE_REASON_REJECT_PERSON_TOO_FAR_AWAY;
    case 7:
    case "AUTHENTICATION_RESPONSE_REASON_REJECT_MORE_THAN_ONE_PERSON":
      return AuthenticationResponseReason.AUTHENTICATION_RESPONSE_REASON_REJECT_MORE_THAN_ONE_PERSON;
    case 8:
    case "AUTHENTICATION_RESPONSE_REASON_REJECT_NO_PERSON_DETECTED":
      return AuthenticationResponseReason.AUTHENTICATION_RESPONSE_REASON_REJECT_NO_PERSON_DETECTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AuthenticationResponseReason.UNRECOGNIZED;
  }
}

export function authenticationResponseReasonToJSON(object: AuthenticationResponseReason): string {
  switch (object) {
    case AuthenticationResponseReason.AUTHENTICATION_RESPONSE_REASON_UNDEFINED:
      return "AUTHENTICATION_RESPONSE_REASON_UNDEFINED";
    case AuthenticationResponseReason.AUTHENTICATION_RESPONSE_REASON_ACCEPT:
      return "AUTHENTICATION_RESPONSE_REASON_ACCEPT";
    case AuthenticationResponseReason.AUTHENTICATION_RESPONSE_REASON_REJECT_FACE_NOT_MATCH_ID:
      return "AUTHENTICATION_RESPONSE_REASON_REJECT_FACE_NOT_MATCH_ID";
    case AuthenticationResponseReason.AUTHENTICATION_RESPONSE_REASON_REJECT_VIDEO_NOT_LIVE:
      return "AUTHENTICATION_RESPONSE_REASON_REJECT_VIDEO_NOT_LIVE";
    case AuthenticationResponseReason.AUTHENTICATION_RESPONSE_REASON_REJECT_VIDEO_BAD_LIGHT:
      return "AUTHENTICATION_RESPONSE_REASON_REJECT_VIDEO_BAD_LIGHT";
    case AuthenticationResponseReason.AUTHENTICATION_RESPONSE_REASON_REJECT_VIDEO_BAD_QUALITY:
      return "AUTHENTICATION_RESPONSE_REASON_REJECT_VIDEO_BAD_QUALITY";
    case AuthenticationResponseReason.AUTHENTICATION_RESPONSE_REASON_REJECT_PERSON_TOO_FAR_AWAY:
      return "AUTHENTICATION_RESPONSE_REASON_REJECT_PERSON_TOO_FAR_AWAY";
    case AuthenticationResponseReason.AUTHENTICATION_RESPONSE_REASON_REJECT_MORE_THAN_ONE_PERSON:
      return "AUTHENTICATION_RESPONSE_REASON_REJECT_MORE_THAN_ONE_PERSON";
    case AuthenticationResponseReason.AUTHENTICATION_RESPONSE_REASON_REJECT_NO_PERSON_DETECTED:
      return "AUTHENTICATION_RESPONSE_REASON_REJECT_NO_PERSON_DETECTED";
    case AuthenticationResponseReason.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface BusinessInformation {
  /**
   * this is name of the project which will be used to identify the project the user
   * is registering in:
   * at the moment we have sajam,sana,crypto,labour_worker but it will expand in the future
   */
  projectName: string;
  /** business id is business identifier that is generated for each business */
  businessId: string;
  /** session identifier is obtained using  RegisterPwaSession method */
  pwaSessionIdentifier: string;
}

/** todo: think of a way to incorporate anonymous users like sana project */
export interface UserInformation {
  /**
   * National Id code of the user
   * in case of projects with anonymous users like sana these information is not required
   */
  nationalId: string;
  /**
   * national Id card serial number located at the back of physical National id card of the user
   * in case of projects with anonymous users like sana these information is not required
   */
  nationalIdSerial: string;
  /** birth date in jalali calender */
  birthDate: DateMessage | undefined;
  sex: Sex;
}

export interface User {
  businessInformation: BusinessInformation | undefined;
  userInformation: UserInformation | undefined;
}

export interface FinalAuthenticationStatus {
  state: AuthenticationState;
  reason: AuthenticationResponseReason;
}

/** message that is sent via call back URL to the business */
export interface UserAuthenticationReport {
  /** Authentication process status */
  status:
    | Status
    | undefined;
  /** Authentication session id for the user which is returned in RegisterUserSession endpoint */
  sessionId: string;
  userInformation:
    | UserInformation
    | undefined;
  /** Authentication status of the user */
  authenticationStatus: FinalAuthenticationStatus | undefined;
  faceMatchingSimilarityPercentage: number | undefined;
}

function createBaseBusinessInformation(): BusinessInformation {
  return { projectName: "", businessId: "", pwaSessionIdentifier: "" };
}

export const BusinessInformation = {
  encode(message: BusinessInformation, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.projectName !== "") {
      writer.uint32(10).string(message.projectName);
    }
    if (message.businessId !== "") {
      writer.uint32(18).string(message.businessId);
    }
    if (message.pwaSessionIdentifier !== "") {
      writer.uint32(26).string(message.pwaSessionIdentifier);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BusinessInformation {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBusinessInformation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.projectName = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.businessId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.pwaSessionIdentifier = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BusinessInformation {
    return {
      projectName: isSet(object.projectName) ? globalThis.String(object.projectName) : "",
      businessId: isSet(object.businessId) ? globalThis.String(object.businessId) : "",
      pwaSessionIdentifier: isSet(object.pwaSessionIdentifier) ? globalThis.String(object.pwaSessionIdentifier) : "",
    };
  },

  toJSON(message: BusinessInformation): unknown {
    const obj: any = {};
    if (message.projectName !== "") {
      obj.projectName = message.projectName;
    }
    if (message.businessId !== "") {
      obj.businessId = message.businessId;
    }
    if (message.pwaSessionIdentifier !== "") {
      obj.pwaSessionIdentifier = message.pwaSessionIdentifier;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BusinessInformation>, I>>(base?: I): BusinessInformation {
    return BusinessInformation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BusinessInformation>, I>>(object: I): BusinessInformation {
    const message = createBaseBusinessInformation();
    message.projectName = object.projectName ?? "";
    message.businessId = object.businessId ?? "";
    message.pwaSessionIdentifier = object.pwaSessionIdentifier ?? "";
    return message;
  },
};

function createBaseUserInformation(): UserInformation {
  return { nationalId: "", nationalIdSerial: "", birthDate: undefined, sex: 0 };
}

export const UserInformation = {
  encode(message: UserInformation, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.nationalId !== "") {
      writer.uint32(10).string(message.nationalId);
    }
    if (message.nationalIdSerial !== "") {
      writer.uint32(18).string(message.nationalIdSerial);
    }
    if (message.birthDate !== undefined) {
      DateMessage.encode(message.birthDate, writer.uint32(26).fork()).ldelim();
    }
    if (message.sex !== 0) {
      writer.uint32(32).int32(message.sex);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserInformation {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserInformation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.nationalId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.nationalIdSerial = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.birthDate = DateMessage.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.sex = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserInformation {
    return {
      nationalId: isSet(object.nationalId) ? globalThis.String(object.nationalId) : "",
      nationalIdSerial: isSet(object.nationalIdSerial) ? globalThis.String(object.nationalIdSerial) : "",
      birthDate: isSet(object.birthDate) ? DateMessage.fromJSON(object.birthDate) : undefined,
      sex: isSet(object.sex) ? sexFromJSON(object.sex) : 0,
    };
  },

  toJSON(message: UserInformation): unknown {
    const obj: any = {};
    if (message.nationalId !== "") {
      obj.nationalId = message.nationalId;
    }
    if (message.nationalIdSerial !== "") {
      obj.nationalIdSerial = message.nationalIdSerial;
    }
    if (message.birthDate !== undefined) {
      obj.birthDate = DateMessage.toJSON(message.birthDate);
    }
    if (message.sex !== 0) {
      obj.sex = sexToJSON(message.sex);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserInformation>, I>>(base?: I): UserInformation {
    return UserInformation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserInformation>, I>>(object: I): UserInformation {
    const message = createBaseUserInformation();
    message.nationalId = object.nationalId ?? "";
    message.nationalIdSerial = object.nationalIdSerial ?? "";
    message.birthDate = (object.birthDate !== undefined && object.birthDate !== null)
      ? DateMessage.fromPartial(object.birthDate)
      : undefined;
    message.sex = object.sex ?? 0;
    return message;
  },
};

function createBaseUser(): User {
  return { businessInformation: undefined, userInformation: undefined };
}

export const User = {
  encode(message: User, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.businessInformation !== undefined) {
      BusinessInformation.encode(message.businessInformation, writer.uint32(10).fork()).ldelim();
    }
    if (message.userInformation !== undefined) {
      UserInformation.encode(message.userInformation, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): User {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUser();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.businessInformation = BusinessInformation.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.userInformation = UserInformation.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): User {
    return {
      businessInformation: isSet(object.businessInformation)
        ? BusinessInformation.fromJSON(object.businessInformation)
        : undefined,
      userInformation: isSet(object.userInformation) ? UserInformation.fromJSON(object.userInformation) : undefined,
    };
  },

  toJSON(message: User): unknown {
    const obj: any = {};
    if (message.businessInformation !== undefined) {
      obj.businessInformation = BusinessInformation.toJSON(message.businessInformation);
    }
    if (message.userInformation !== undefined) {
      obj.userInformation = UserInformation.toJSON(message.userInformation);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<User>, I>>(base?: I): User {
    return User.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<User>, I>>(object: I): User {
    const message = createBaseUser();
    message.businessInformation = (object.businessInformation !== undefined && object.businessInformation !== null)
      ? BusinessInformation.fromPartial(object.businessInformation)
      : undefined;
    message.userInformation = (object.userInformation !== undefined && object.userInformation !== null)
      ? UserInformation.fromPartial(object.userInformation)
      : undefined;
    return message;
  },
};

function createBaseFinalAuthenticationStatus(): FinalAuthenticationStatus {
  return { state: 0, reason: 0 };
}

export const FinalAuthenticationStatus = {
  encode(message: FinalAuthenticationStatus, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.state !== 0) {
      writer.uint32(8).int32(message.state);
    }
    if (message.reason !== 0) {
      writer.uint32(16).int32(message.reason);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FinalAuthenticationStatus {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFinalAuthenticationStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.reason = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FinalAuthenticationStatus {
    return {
      state: isSet(object.state) ? authenticationStateFromJSON(object.state) : 0,
      reason: isSet(object.reason) ? authenticationResponseReasonFromJSON(object.reason) : 0,
    };
  },

  toJSON(message: FinalAuthenticationStatus): unknown {
    const obj: any = {};
    if (message.state !== 0) {
      obj.state = authenticationStateToJSON(message.state);
    }
    if (message.reason !== 0) {
      obj.reason = authenticationResponseReasonToJSON(message.reason);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FinalAuthenticationStatus>, I>>(base?: I): FinalAuthenticationStatus {
    return FinalAuthenticationStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FinalAuthenticationStatus>, I>>(object: I): FinalAuthenticationStatus {
    const message = createBaseFinalAuthenticationStatus();
    message.state = object.state ?? 0;
    message.reason = object.reason ?? 0;
    return message;
  },
};

function createBaseUserAuthenticationReport(): UserAuthenticationReport {
  return {
    status: undefined,
    sessionId: "",
    userInformation: undefined,
    authenticationStatus: undefined,
    faceMatchingSimilarityPercentage: undefined,
  };
}

export const UserAuthenticationReport = {
  encode(message: UserAuthenticationReport, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.status !== undefined) {
      Status.encode(message.status, writer.uint32(10).fork()).ldelim();
    }
    if (message.sessionId !== "") {
      writer.uint32(18).string(message.sessionId);
    }
    if (message.userInformation !== undefined) {
      UserInformation.encode(message.userInformation, writer.uint32(26).fork()).ldelim();
    }
    if (message.authenticationStatus !== undefined) {
      FinalAuthenticationStatus.encode(message.authenticationStatus, writer.uint32(34).fork()).ldelim();
    }
    if (message.faceMatchingSimilarityPercentage !== undefined) {
      DoubleValue.encode({ value: message.faceMatchingSimilarityPercentage! }, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserAuthenticationReport {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserAuthenticationReport();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.status = Status.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.sessionId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.userInformation = UserInformation.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.authenticationStatus = FinalAuthenticationStatus.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.faceMatchingSimilarityPercentage = DoubleValue.decode(reader, reader.uint32()).value;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserAuthenticationReport {
    return {
      status: isSet(object.status) ? Status.fromJSON(object.status) : undefined,
      sessionId: isSet(object.sessionId) ? globalThis.String(object.sessionId) : "",
      userInformation: isSet(object.userInformation) ? UserInformation.fromJSON(object.userInformation) : undefined,
      authenticationStatus: isSet(object.authenticationStatus)
        ? FinalAuthenticationStatus.fromJSON(object.authenticationStatus)
        : undefined,
      faceMatchingSimilarityPercentage: isSet(object.faceMatchingSimilarityPercentage)
        ? Number(object.faceMatchingSimilarityPercentage)
        : undefined,
    };
  },

  toJSON(message: UserAuthenticationReport): unknown {
    const obj: any = {};
    if (message.status !== undefined) {
      obj.status = Status.toJSON(message.status);
    }
    if (message.sessionId !== "") {
      obj.sessionId = message.sessionId;
    }
    if (message.userInformation !== undefined) {
      obj.userInformation = UserInformation.toJSON(message.userInformation);
    }
    if (message.authenticationStatus !== undefined) {
      obj.authenticationStatus = FinalAuthenticationStatus.toJSON(message.authenticationStatus);
    }
    if (message.faceMatchingSimilarityPercentage !== undefined) {
      obj.faceMatchingSimilarityPercentage = message.faceMatchingSimilarityPercentage;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserAuthenticationReport>, I>>(base?: I): UserAuthenticationReport {
    return UserAuthenticationReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserAuthenticationReport>, I>>(object: I): UserAuthenticationReport {
    const message = createBaseUserAuthenticationReport();
    message.status = (object.status !== undefined && object.status !== null)
      ? Status.fromPartial(object.status)
      : undefined;
    message.sessionId = object.sessionId ?? "";
    message.userInformation = (object.userInformation !== undefined && object.userInformation !== null)
      ? UserInformation.fromPartial(object.userInformation)
      : undefined;
    message.authenticationStatus = (object.authenticationStatus !== undefined && object.authenticationStatus !== null)
      ? FinalAuthenticationStatus.fromPartial(object.authenticationStatus)
      : undefined;
    message.faceMatchingSimilarityPercentage = object.faceMatchingSimilarityPercentage ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
